// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em
}
code.hljs {
  padding: 3px 5px
}

.hljs {
  color: var(--code-foreground-color);
  background: var(--code-background-color);
}
.hljs-keyword,
.hljs-selector-tag,
.hljs-literal,
.hljs-section,
.hljs-attr,
.hljs-link {
  color: var(--code-highlight-color);
}
.hljs-subst {
  /* default */
  
}
.hljs-string,
.hljs-title,
.hljs-name,
.hljs-type,
.hljs-attribute,
.hljs-symbol,
.hljs-bullet,
.hljs-built_in,
.hljs-addition,
.hljs-variable,
.hljs-template-tag,
.hljs-template-variable {
  color: var(--code-secondary-highlight-color);
  font-style: italic;
}
.hljs-comment,
.hljs-quote,
.hljs-deletion,
.hljs-meta {
  color: var(--code-secondary-highlight-color);
}
.hljs-keyword,
.hljs-selector-tag,
.hljs-literal,
.hljs-title,
.hljs-section,
.hljs-doctag,
.hljs-type,
.hljs-name,
.hljs-strong {
  color: var(--code-neutral-color);
  font-weight: bold
}
.hljs-emphasis {
  font-style: italic
}`, "",{"version":3,"sources":["webpack://./styles/highlight-js.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB;AACF;AACA;EACE;AACF;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;AACA;;;;;;EAME,kCAAkC;AACpC;AACA;EACE,YAAY;;AAEd;AACA;;;;;;;;;;;;EAYE,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;;;;EAIE,4CAA4C;AAC9C;AACA;;;;;;;;;EASE,gCAAgC;EAChC;AACF;AACA;EACE;AACF","sourcesContent":["pre code.hljs {\n  display: block;\n  overflow-x: auto;\n  padding: 1em\n}\ncode.hljs {\n  padding: 3px 5px\n}\n\n.hljs {\n  color: var(--code-foreground-color);\n  background: var(--code-background-color);\n}\n.hljs-keyword,\n.hljs-selector-tag,\n.hljs-literal,\n.hljs-section,\n.hljs-attr,\n.hljs-link {\n  color: var(--code-highlight-color);\n}\n.hljs-subst {\n  /* default */\n  \n}\n.hljs-string,\n.hljs-title,\n.hljs-name,\n.hljs-type,\n.hljs-attribute,\n.hljs-symbol,\n.hljs-bullet,\n.hljs-built_in,\n.hljs-addition,\n.hljs-variable,\n.hljs-template-tag,\n.hljs-template-variable {\n  color: var(--code-secondary-highlight-color);\n  font-style: italic;\n}\n.hljs-comment,\n.hljs-quote,\n.hljs-deletion,\n.hljs-meta {\n  color: var(--code-secondary-highlight-color);\n}\n.hljs-keyword,\n.hljs-selector-tag,\n.hljs-literal,\n.hljs-title,\n.hljs-section,\n.hljs-doctag,\n.hljs-type,\n.hljs-name,\n.hljs-strong {\n  color: var(--code-neutral-color);\n  font-weight: bold\n}\n.hljs-emphasis {\n  font-style: italic\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
